import paronApi from '@/utils/paron-api'

export default {
    getAllPages(page = 1, perPage = 60) {
        return paronApi.get(`page/?page=${page}&per_page=${perPage}`)
    },

    getPageById(id) {
        return paronApi.get(`page/${id}`)
    },

    createPage(data) {
        return paronApi.uploadFile('page/new', data)
    },

    editPageById(id, data) {
        return paronApi.uploadFile(`page/${id}/edit`, data)
    },

    deletePageById(id) {
        return paronApi.delete(`page/${id}`)
    }

}
